module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zM1.667 10c0-4.583 3.75-8.333 8.333-8.333s8.333 3.75 8.333 8.333-3.75 8.333-8.333 8.333S1.667 14.583 1.667 10zm13.077-.938c.518.761.32 1.798-.44 2.316L9.27 14.803a1.667 1.667 0 0 1-2.604-1.378v-6.85A1.667 1.667 0 0 1 9.27 5.197l5.032 3.425c.174.118.323.267.44.44zm-6.41-2.487v6.85L13.365 10 8.333 6.575z\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/play-sequences.svg
// module id = bOpv
// module chunks = 89